export const SLICE_NAME = 'app';
